import { motion } from 'framer-motion';

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
}: {
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className={align === 'center' ? 'text-center mx-auto' : ''}
    >
      <p className="eyebrow mb-3">{eyebrow}</p>
      <h2 className="font-display font-semibold text-3xl md:text-4xl lg:text-5xl leading-tight tracking-[-0.01em] text-maroon">
        {title}
      </h2>
      {description && (
        <p className={`mt-4 text-base md:text-lg leading-relaxed text-ink-2 ${align === 'center' ? 'max-w-[60ch] mx-auto' : 'max-w-[60ch]'}`}>
          {description}
        </p>
      )}
    </motion.div>
  );
}
